/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { Tabs, TabsProps } from 'antd'
import { useTranslation } from 'react-i18next'
import { Roles } from '@/pages/auth/AccessManager/Roles'
// import { Users } from '@/pages/contract/AccessManager/Users'

export function AccessManager(
  props: React.PropsWithoutRef<{
    scene: 'contract' | 'billing'
  }>,
) {
  const { scene } = props
  const { t } = useTranslation()

  const items: TabsProps['items'] = [
    {
      key: 'roles',
      label: t('Roles'),
      children: <Roles scene={scene} />,
    },
    // {
    //   key: 'users',
    //   label: t('Users'),
    //   children: <Users />,
    // },
  ]

  return <Tabs items={items} />
}
